import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/DynamicMerchants';

export const DYNAMIC_MERCHANTS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const DYNAMIC_MERCHANTS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const DYNAMIC_MERCHANTS_FILTER_CHANGED = `${rootActionPath}/FILTER/CHANGED`;
